import { FC } from 'react';
import { Image, Skeleton } from "antd";

import useInfoScreen from '../../useInfoScreen';
import { EditableContent } from "../EditableContent";
import { ScreenButtons } from "../ScreenButtons";
import { ScreenButton } from "../ScreenButton";
import { ScreenLayout } from "../ScreenLayout";
import email from "../../images/email.png";
import styles from './index.module.scss';

export const RegistrationSendLetterScreen: FC<{ screenId: number }> = ({ screenId }) => {
  const { data, onEdit, loading } = useInfoScreen(screenId);
  if (loading) {
    return <Skeleton active={true} />;
  }
  return(
    <ScreenLayout hiddenTabs>
      <Image
        width={170}
        height={170}
        alt="email"
        preview={false}
        src={email}
      />
      <div className={styles.body}>
        <EditableContent type="header" maxLength={90} onSave={onEdit}>
          {data?.header}
        </EditableContent>
        <EditableContent type="body" maxLength={130} onSave={onEdit}>
          {data?.body}
        </EditableContent>
      </div>
      <ScreenButtons>
        <ScreenButton>
          На главную
        </ScreenButton>
      </ScreenButtons>
    </ScreenLayout>
  )
}
